module.exports = __webpack_public_path__ + "static/media/apple-button.dd735e5f.svg";